var map = {
	"./3-reasons-why-you-should-learn-public-speaking.md": [
		909,
		909
	],
	"./5-tips-to-become-a-better-speaker.md": [
		238,
		238
	],
	"./template.md": [
		563,
		563
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 639;
module.exports = webpackAsyncContext;